import React from "react";
import "./CompanyInfo.css";
const ComoanyInfo = () => {
  return (
    <>
      <div className="companyinfo-sec">
        <div className="companyinfo-con">
          <div className="companyinfo-part">
            <p className="companyinfo-heading">WELCOME TO OUR COMPANY !</p>
            <p className="companyinfo-desc">
              Jay Ambe Corporation is the leading Kraft Paper and board supplier
              across India today. We are the largest dealers and distributors of
              Kraft Paper and Kraft board, with an experience that spans across
              three decades. The infrastructural sophistication, a manufacturing
              diversity and a splendid distribution network are some of the key
              features of our organization.
            </p>
          </div>
          <div className="companyinfo-part">
            <p className="companyinfo-heading">OUR STRENGTH</p>
            <p className="companyinfo-desc">
              At Jay Ambe Corporation we have made it a habit to exceed client
              expectations and apply our abilities to create, enhance and build
              a successful enterprise. We count our vast and expanding
              distribution network and a resourceful alliance with global
              suppliers as some of our key strengths.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComoanyInfo;
